<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
<template lang="pug">
  div#app
    Header
    ClassMenu(v-show="menuShowFlag")
    router-view(v-show="!menuShowFlag")
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import Vuei18n from "vue-i18n";
import Header from './components/Header.vue';
import ClassMenu from './components/ClassMenu.vue';

export default {
  name: 'Home',
  components:{
    Header,
    ClassMenu
  },
  data(){
    return {
      menuShowFlag:true
    }
  },
  created(){
    
  },
  methods:{
    checkMenuShowFlag() {
      if(this.$route.path.split("/").length > 2) {
        this.menuShowFlag = false
      } else{
        this.menuShowFlag = true
      }
    }
  },
  computed:{
    
  },
  mounted(){
    this.checkMenuShowFlag()
  },
  watch: {
      $route(to, from) {
        this.checkMenuShowFlag()
      }
  }
}
</script>

<style lang="scss">
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  #app .van-nav-bar{
    padding-top: 20pt;
  }
}
/* iphone xr / 11 */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  #app .van-nav-bar{
    padding-top: 20pt;
  }
}
/* iphone xs max / 11 pro max */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  #app .van-nav-bar{
    padding-top: 20pt;
  }
}
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  #app .van-nav-bar{
    padding-top: 20pt;
  }
}
@media only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
  #app .van-nav-bar{
    padding-top: 20pt;
  }
}
@media only screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
  #app .van-nav-bar{
    padding-top: 20pt;
  }
}
/* iphone 14 pro */
@media only screen and (device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) {
  #app .van-nav-bar{
    padding-top: 30pt;
  }
}
/* iphone 14 pro max */
@media only screen and (device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3) {
  #app .van-nav-bar{
    padding-top: 30pt;
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  background: url("assets/list_bg.jpg") bottom center no-repeat;
  background-size: cover;
  background-color: #677166;
  overflow-x: hidden;
  overflow-y: auto;
}
html, body {
  background-color: #1c1f1f;
  font: 14px / 1.5 "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", "Helvetica Neue", Helvetica, Arial, sans-serif, 宋体;
  margin: 0;
  width: 100%;
  height: 100%;
}
.el-aside {
  height: 600px;
  overflow-y: scroll;
  background-color: #fff;
}
</style>